import { LoadingButton } from '@mui/lab'
import { FragmentType, getFragmentData } from '../gql'
import { RichListLoader } from './richListLoader'
import { RichListTableFragment } from './RichListTable'
import { useTransition } from 'react'
import { ExtractQueryRefHandlers } from '../util/apolloTypeUtils'

type FetchMoreType = ExtractQueryRefHandlers<RichListLoader>['fetchMore']

export function RichListLoadMoreButton({
  query,
  fetchMore
}: {
  query: FragmentType<typeof RichListTableFragment>
  fetchMore: FetchMoreType
}) {
  const [isLoading, startTransition] = useTransition()
  function handleFetchMore(args: Parameters<typeof fetchMore>[0]) {
    startTransition(() => {
      fetchMore(args)
    })
  }
  const { items, hasMore } = getFragmentData(RichListTableFragment, query)
  if (!hasMore) return null
  return (
    <LoadingButton
      loading={isLoading}
      onClick={(e) => {
        handleFetchMore({
          variables: {
            richListCursor: {
              balance: items[items.length - 1].balance,
              balanceChange: items[items.length - 1].balanceChange,
              address: items[items.length - 1].address.address
            }
          }
        })
      }}
    >
      Load more
    </LoadingButton>
  )
}
